import script from "./MsgListComp.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgListComp.vue?vue&type=script&setup=true&lang=js"

import "./MsgListComp.vue?vue&type=style&index=0&id=399c8269&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-399c8269"]])

export default __exports__